/*** IMPORTS FROM imports-loader ***/
(function() {

// Once generated by CoffeeScript 1.9.3, but now lives as pure JS
/* eslint-disable */
(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  this.SequenceDescriptor = (function(superClass) {
    extend(SequenceDescriptor, superClass);

    function SequenceDescriptor() {
      return SequenceDescriptor.__super__.constructor.apply(this, arguments);
    }

    return SequenceDescriptor;

  })(XModule.Descriptor);

}).call(this);

}.call(window));


// WEBPACK FOOTER //
// ./common/static/xmodule/descriptors/js/001-c88750f95f4884a8666f9261eecfa285.js